// React slug → Wix product-page slug on toneregistry.com.
// Inverted from /app/frontend/src/pages/WixProductRedirect.js so that whenever
// we add a new digital product mapping there, we only need to update one place.
var REACT_TO_WIX_SLUG = {
  // ForScore indexed Real Books — C
  'real-book-vol-1-c': 'real-book-vol-1-in-c-indexed-forscore',
  'real-book-vol-2-c': 'real-book-vol-2-in-c-indexed-forscore',
  'real-book-vol-3-c': 'copy-of-real-book-vol-3-in-c-indexed-forscore',
  'new-real-book-vol-1-c': 'the-new-real-book-vol-1-in-c-indexed-forscore',
  'new-real-book-vol-2-c': 'the-new-real-book-vol-2-in-c-indexed-forscore',
  'new-real-book-vol-3-c': 'the-new-real-book-vol-3-in-c-indexed-forscore',
  'real-christmas-book-c': 'the-real-christmas-book-in-c',

  // ForScore indexed Real Books — Bb
  'real-book-vol-1-bb': 'real-book-vol-1-in-bb-indexed',
  'real-book-vol-2-bb': 'real-book-vol-2-in-bb-indexed',
  'real-book-vol-3-bb': 'real-book-vol-3-in-bb-indexed-forscore',
  'new-real-book-vol-1-bb': 'the-new-real-book-vol-1-in-bb',
  'new-real-book-vol-2-bb': 'the-new-real-book-vol-2-in-bb',
  'new-real-book-vol-3-bb': 'the-new-real-book-vol-3-in-bb-index-forscore',

  // ForScore indexed Real Books — Eb
  'real-book-vol-1-eb': 'real-book-vol-1-in-eb-indexed-forscore',
  'real-book-vol-2-eb': 'copy-of-real-book-vol-2-in-eb-indexed-forscore',
  'new-real-book-vol-1-eb': 'the-new-real-book-vol-1-in-eb-indexed-forscore',
  'new-real-book-vol-2-eb': 'the-new-real-book-vol-2-in-eb-indexed-forscore',
  'new-real-book-vol-3-eb': 'copy-of-the-new-real-book-vol-3-in-eb-indexed-forscore',

  // ForScore indexed Real Books — Bass Clef
  'real-book-vol-1-bass': 'real-book-vol-1-in-bass-clef-indexed-forscore',

  // Digital albums / charts
  'art-in-trumpet-album': 'art-in-trumpet',
  'tuning-chart': 'tuning-chart',

  // Arrangements (Isaías's trumpet transcriptions, sold as PDFs)
  'malaguena-solo': 'malague%C3%B1a-solo-acapella-version',
  'gliere-horn-concerto': 'glier%C3%A9-french-horn-concerto-as-played-by-sergei-nakariakov',
  'espada-de-la-noche': 'espada-de-la-noche',
  'arabesque-no-1': 'arabesque-no-1-1',
  'green-hornet-acapella': 'the-green-hornet-acapella',
  'danse-macabre': 'danse-macabre-as-recorded-on-art-in-trumpet',
  'le-coucou': 'le-coucou',
  'i-cant-get-started': 'i-can-t-get-started-as-played-by-bunny-barrigan',
  'blue-rondo-a-la-turk': 'blue-rondo-a-la-turk-as-played-by-tine-helseth',
  'oblivion': 'oblivion-as-played-by-tine-helseth',
  'libertango': 'libertango-as-played-by-tine-helseth',
  'caprice-24': 'caprice-24',
  'les-chemins-de-lamour': 'les-chemins-de-l-amoure',
  'pavane-pour-une-infante-defunte': 'pavane-pour-une-infante-defunte',
  'green-hornet-big-band': 'the-green-hornet-full-big-band',
  'hora-staccato': 'hora-staccato',
  'danse-espagnol': 'danse-espagnol',
  'meditation': 'meditation',
  'chanson-arabe': 'chanson-arabe',
  'campanella': 'campanella-by-paganini',
  'le-plus-que-lente': 'le-plus-que-lente',
  'romanian-folk-dances': 'romanian-folk-dances',
  'mendelssohn-violin-concerto': 'mendelssohn-violin-concerto',
};

var WIX_BASE = 'https://www.toneregistry.com/product-page/';

// Physical products that we intentionally route to the Wix storefront for
// purchase (same UX as digital files — "Buy Now" opens toneregistry.com).
// Add a slug here to opt a physical product into the Wix checkout path
// without having to mark it as `sheet-music`/`digital`.
var FORCE_WIX_CHECKOUT_SLUGS = new Set([
  // Add slugs here to opt a physical product into the Wix checkout flow.
]);

// A product is considered digital (i.e. delivered by ToneRegistry/Wix) when
// either Sanity marks it so OR it's a known sheet-music/forscore category,
// OR the owner has opted it into the Wix-checkout list above.
export function isDigitalProduct(product) {
  if (!product) return false;
  if (product.redirectToWix === true) return true;
  // Explicit admin override (Catalog tab → Type)
  if (product.isDigital === true) return true;
  if (product.isDigital === false) return false;
  var slug = product.slug || '';
  if (FORCE_WIX_CHECKOUT_SLUGS.has(slug)) return true;
  var cat = product.category || '';
  return cat === 'sheet-music' || cat === 'digital';
}

// Return the Wix product-page URL for a digital product, or null if we can't
// resolve it (defensive — never break the page for a misconfigured product).
//
// Resolution order:
//   1. Sanity-provided `wixUrl` (admin override)
//   2. Reverse-lookup in REACT_TO_WIX_SLUG using the React slug
//   3. null (caller should fall back to a disabled "Coming soon" button)
export function getDigitalRedirectUrl(product) {
  if (!product) return null;
  if (!isDigitalProduct(product)) return null;
  if (product.wixUrl) {
    // Honor whatever the admin entered, but normalize bare slugs into full URLs.
    if (/^https?:\/\//i.test(product.wixUrl)) return product.wixUrl;
    return WIX_BASE + String(product.wixUrl).replace(/^\/+/, '');
  }
  var slug = product.slug || '';
  var wixSlug = REACT_TO_WIX_SLUG[slug];
  if (!wixSlug) return null;
  return WIX_BASE + wixSlug;
}

// Return the Wix product-page URL for ANY product (physical or digital).
// The React checkout has been retired (per user request 2026-02-18) — every
// product now routes the customer to its Wix counterpart for purchase, the
// same way digital products do.
//
// Resolution order:
//   1. Explicit product.wixUrl  (full URL or bare slug)
//   2. Mapped digital-product slug (REACT_TO_WIX_SLUG lookup)
//   3. ToneRegistry default: WIX_BASE + product.slug
export function getWixRedirectUrl(product) {
  if (!product) return null;
  if (product.wixUrl) {
    if (/^https?:\/\//i.test(product.wixUrl)) return product.wixUrl;
    return WIX_BASE + String(product.wixUrl).replace(/^\/+/, '');
  }
  var slug = product.slug || '';
  var mapped = REACT_TO_WIX_SLUG[slug];
  if (mapped) return WIX_BASE + mapped;
  if (!slug) return null;
  return WIX_BASE + slug;
}
